import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const whatsappMessage = `Hello Jupiter Cosmic,\n\nName: ${name}\nEmail: ${email}\nMessage: ${message}`;
    const whatsappUrl = `https://wa.me/6281222667763?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="relative py-16 sm:py-24 md:py-32 px-4 sm:px-6" data-testid="contact-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16" data-aos="fade-up">
          <h2 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4" data-testid="contact-title">Let's Build Something Powerful.</h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm sm:text-base px-4">
            Tell us about your vision. We'll turn it into reality.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 sm:gap-12">
          <div data-aos="fade-right">
            <div className="glass-card p-6 sm:p-8 mb-6">
              <h3 className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6">Get in Touch</h3>
              
              <div className="space-y-4 sm:space-y-6">
                <div className="flex items-start space-x-3 sm:space-x-4" data-testid="contact-email">
                  <div className="p-2 sm:p-3 rounded-lg bg-[#00E5FF]/10 flex-shrink-0">
                    <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-[#00E5FF]" />
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-400 mb-1">Email</div>
                    <div className="font-medium text-sm sm:text-base">admin@jupitercosmic.com</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3 sm:space-x-4" data-testid="contact-phone">
                  <div className="p-2 sm:p-3 rounded-lg bg-[#00E5FF]/10 flex-shrink-0">
                    <Phone className="w-4 h-4 sm:w-5 sm:h-5 text-[#00E5FF]" />
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-400 mb-1">Phone</div>
                    <div className="font-medium text-sm sm:text-base">+62 812 2266 7763 / +62 813 3295 1122</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3 sm:space-x-4" data-testid="contact-location">
                  <div className="p-2 sm:p-3 rounded-lg bg-[#00E5FF]/10 flex-shrink-0">
                    <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-[#00E5FF]" />
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-400 mb-1">Location</div>
                    <div className="font-medium text-sm sm:text-base">Indonesia</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div data-aos="fade-left">
            <form onSubmit={handleSubmit} className="glass-card p-6 sm:p-8" data-testid="contact-form">
              <div className="space-y-4 sm:space-y-6">
                <div>
                  <label className="block text-sm font-medium mb-2" htmlFor="name">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg bg-white/5 border border-white/10 focus:border-[#00E5FF] focus:outline-none transition-colors text-sm sm:text-base"
                    placeholder="Your name"
                    data-testid="contact-name-input"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg bg-white/5 border border-white/10 focus:border-[#00E5FF] focus:outline-none transition-colors text-sm sm:text-base"
                    placeholder="your.email@example.com"
                    data-testid="contact-email-input"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg bg-white/5 border border-white/10 focus:border-[#00E5FF] focus:outline-none transition-colors resize-none text-sm sm:text-base"
                    placeholder="Tell us about your project..."
                    data-testid="contact-message-input"
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full glow-button flex items-center justify-center space-x-2 text-sm sm:text-base"
                  data-testid="contact-submit-button"
                >
                  <span>Send Message</span>
                  <Send className="w-4 h-4" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
